module.exports = __webpack_public_path__ + "img/beijing.20292d7d.jpg";